import { BeamInput } from '@core/const'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: BeamInput = {
  rebarStrength: 0,
  beamSpan: 0,
}

interface BeamContext {
  form: UseFormReturn<BeamInput>
  result: number | null
  setResult: Dispatch<SetStateAction<number | null>>
}

const context = createContext<BeamContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<BeamInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<number | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function BeamProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useBeam = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
